import React, { useRef, useState } from 'react';
import { hash } from '@zonofi/zono-money-helpers';
import { ProductVariantCategory } from '@zonofi/zono-money-store';

export const CategoryTag: React.FC<{ category: ProductVariantCategory }> = ({
  category,
}) => {
  const tagColors = [
    { background: '#CEEAF9', color: '#164B68' },
    { background: '#FFEBC2', color: '#734D00' },
    { background: '#F4ECFF', color: '#3F1B73' },
    { background: '#EFFBDA', color: '#7AA049' },
    { background: '#DBD1F5', color: '#24118A' },
    { background: '#F6DDD4', color: '#A38E4E' },
    { background: '#FDF6D6', color: '#5E9A75' },
  ];
  const selectedColor =
    tagColors[hash(category?.categoryName, tagColors.length)];

  const textRef = useRef<HTMLSpanElement>(null);
  const [tooltip, setTooltip] = useState<{
    visible: boolean;
    x: number;
    y: number;
  }>({ visible: false, x: 0, y: 0 });

  const handleClick = (e: React.MouseEvent) => {
    const el = textRef.current;
    if (!el) return;
    const isTruncated = el.scrollWidth > el.clientWidth;
    if (!isTruncated) return;
    e.stopPropagation();
    const rect = el.getBoundingClientRect();
    setTooltip({ visible: true, x: rect.left, y: rect.bottom + 4 });
  };

  const handleTooltipClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    setTooltip({ visible: false, x: 0, y: 0 });
  };

  return (
    <>
      <div
        className="category-tag"
        style={{
          backgroundColor:
            category?.categoryCode === ''
              ? '#F0F0F0'
              : selectedColor?.background,
        }}
        onClick={handleClick}
      >
        <span ref={textRef} className="category-tag-text font-primary">
          {category?.categoryName}
        </span>
      </div>

      {tooltip.visible && (
        <>
          <div
            className="category-tag-tooltip-overlay"
            onClick={handleTooltipClose}
          />
          <div
            className="category-tag-tooltip"
            style={{ top: tooltip.y, left: tooltip.x }}
            onClick={(e) => e.stopPropagation()}
          >
            {category?.categoryName}
          </div>
        </>
      )}
    </>
  );
};
